
const ValidationProgress = ({ validations, currentUserAccountId }) => {
  const totalValidations = validations.length;
  const approvedCount = validations.filter(v => v.status === 'Approved').length;
  const rejectedCount = validations.filter(v => v.status === 'Rejected').length;
  const pendingCount = validations.filter(v => v.status === 'Pending').length;
  
  const progressPercentage = totalValidations > 0 ? 
    ((approvedCount + rejectedCount) / totalValidations) * 100 : 0;

  // Vérifier si l'utilisateur courant a déjà validé
  const userHasValidated = validations.some(v => 
    v.validatedByAccountId === currentUserAccountId && 
    (v.status === 'Approved' || v.status === 'Rejected')
  );

  return (
    <div className="card mb-4">
      <div className="card-header bg-light">
        <h6 className="mb-0">
          <i className="fa-graph-up me-2"></i>
          Progression de la Validation
        </h6>
      </div>
      <div className="card-body">
        {/* Barre de progression */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small">Progression globale</span>
            <span className="text-muted small">{Math.round(progressPercentage)}%</span>
          </div>
          <div className="progress" style={{ height: '8px' }}>
            <div 
              className="progress-bar bg-success" 
              style={{ width: `${(approvedCount / totalValidations) * 100}%` }}
              title={`Approuvés: ${approvedCount}`}
            ></div>
            <div 
              className="progress-bar bg-danger" 
              style={{ width: `${(rejectedCount / totalValidations) * 100}%` }}
              title={`Rejetés: ${rejectedCount}`}
            ></div>
          </div>
        </div>

        {/* Statistiques détaillées */}
        <div className="row text-center">
          <div className="col-4">
            <div className="border-end">
              <div className="h5 mb-1 text-success">{approvedCount}</div>
              <small className="text-muted">Approuvés</small>
            </div>
          </div>
          <div className="col-4">
            <div className="border-end">
              <div className="h5 mb-1 text-danger">{rejectedCount}</div>
              <small className="text-muted">Rejetés</small>
            </div>
          </div>
          <div className="col-4">
            <div>
              <div className="h5 mb-1 text-warning">{pendingCount}</div>
              <small className="text-muted">En Attente</small>
            </div>
          </div>
        </div>

        {/* Indicateur de validation utilisateur */}
        {userHasValidated && (
          <div className="mt-3 p-2 bg-success bg-opacity-10 rounded text-center">
            <i className="fa fa-person-check text-success me-1"></i>
            <small className="text-success">
              <strong>Vous avez déjà validé cette demande</strong>
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidationProgress;